"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect } from "react";
import { usePathname } from "next/navigation";
import { useReportWebVitals } from "next/web-vitals";
import { recordWebVital, recordSoftNavEnd } from "@/lib/telemetry";

/**
 * Feeds Next.js' Core Web Vitals (via the built-in `useReportWebVitals`) into
 * the OTel meter. Render-null; mount once near the app root. A no-op unless
 * browser telemetry is enabled (see `initTelemetry`).
 */
export function WebVitalsReporter() {
  useReportWebVitals(recordWebVital);
  return null;
}

/**
 * Records the duration of client-side (soft) navigations. The start is marked
 * by the blocking router (`useBlockableRouter`); this closes the measurement
 * when the destination `pathname` commits, after two animation frames so the
 * timing reflects the new route having painted. Mount once near the app root
 * so it persists across navigations (the component that triggered the nav is
 * usually unmounted by the time it completes).
 */
export function SoftNavigationTracker() {
  const $ = _c(3);
  const pathname = usePathname();
  let t0;
  let t1;
  if ($[0] !== pathname) {
    t0 = () => {
      const raf = requestAnimationFrame(() => {
        requestAnimationFrame(() => recordSoftNavEnd(pathname));
      });
      return () => cancelAnimationFrame(raf);
    };
    t1 = [pathname];
    $[0] = pathname;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  return null;
}